(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kg-product-menu-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('.kg-products-menu-drawer')) return;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
  }, true);
  } catch(e) { console.error(e); }
})();

})();
